import { env } from '@/constants/env';

const { VITE_APP_ENV } = env;

export function stonlyTrack(...params: any[]) {
  if (VITE_APP_ENV !== 'development' && window.stonlyTrack) {
    window.stonlyTrack(...params);
  }
}
